export default [
    {
        path: "/voucher/canteen/payment",
        component: () => import("@/App/Canteen/Voucher/Payment/Components/List.vue"),
        name: "voucher.canteen.payment",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/payment/create",
        component: () => import("@/App/Canteen/Voucher/Payment/Components/Create.vue"),
        name: "voucher.canteen.payment.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/payment/:id/edit",
        component: () => import("@/App/Canteen/Voucher/Payment/Components/Edit.vue"),
        name: "voucher.canteen.payment.edit",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/payment/pre-sanction-payment",
        component: () => import("@/App/Canteen/Voucher/Payment/Components/PreSanctionPayment.vue"),
        name: "canteen.voucher.pre-sanction.payment",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/payment/pre-sanction-bank",
        component: () => import("@/App/Canteen/Voucher/Payment/Components/PreSanctionBank.vue"),
        name: "canteen.voucher.pre-sanction.bank",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/payment/bank",
        component: () => import("@/App/Canteen/Voucher/Payment/Components/Bank.vue"),
        name: "canteen.voucher.bank.deposit",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/payment/note-sheet-payment",
        component: () => import("@/App/Canteen/Voucher/Payment/Components/NoteSheetPayment.vue"),
        name: "canteen.voucher.note.sheet.payment",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/payment/:id/view",
        component: () => import("@/App/Canteen/Voucher/Payment/Components/View.vue"),
        name: "voucher.canteen.payment.view",
        meta: {
            requiresAuth: true,
        },
    },
];
